module.exports = __webpack_public_path__ + "img/1542116640.335a917e.jpg";